// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { getUnitLabelForMetersAndFeet } from "helpers/unitConversion";
import { stringMustBeWithinRange } from "validators/common";

const validateAntennaCenterline = ({ centerline, centerlineUnit }, error) => {
  // NOTE - due to a redux-form bug, centerline might be undefined. If so, get outta here.
  // https://github.com/erikras/redux-form/issues/3366
  // check for fasley, this could be an empty string or undefined
  if (!centerline) {
    return;
  }

  const unit = getUnitLabelForMetersAndFeet(centerlineUnit);
  const err =
    centerlineUnit === "SI"
      ? stringMustBeWithinRange(centerline, -99.999, 1000.0, unit)
      : stringMustBeWithinRange(centerline, -328.08, 3280.84, unit);

  if (err) {
    error.centerline = err;
  }
};

export default validateAntennaCenterline;
